import { useState, useEffect } from 'react';
import ModalBase from '.';
import { Alert, Input, Select } from '@piggytechng/component-library';
import { OverideInputStyle } from '../../helpers/utils';
import { IoEyeSharp } from 'react-icons/io5';
import { FaEyeSlash } from 'react-icons/fa';
import { ModalInvestifyActionProps } from '../../types';
import { verifyAdminPassword } from '../../helpers/utils/auth-payload';

const ModalInvestifyAction = ({
  modalIsOpen,
  setIsOpen,
  title,
  action,
  actionColor = '#6624CE',
  isLoading = false,
}: ModalInvestifyActionProps) => {
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState('');
  const [formData, setFormData] = useState({
    units: '',
    amountPaid: '',
    fundFlex: '',
  });

  useEffect(() => {
    if (modalIsOpen) {
      setPassword('');
      setFormData({
        units: '',
        amountPaid: '',
        fundFlex: '',
      });
    }
  }, [modalIsOpen]);

  const onButtonClick = async (e: React.MouseEvent) => {
    e.preventDefault();

    if (!formData.units || !formData.amountPaid) {
      Alert.error('Units and Amount Paid are required!');
      return;
    }

    if (password === '') {
      Alert.error('Please enter your password to proceed!');
      return;
    }

    if (!(await verifyAdminPassword(password))) return;

    action({
      units: Number(formData.units),
      fundFlex: formData.fundFlex === 'true',
      amountPaid: Number(formData.amountPaid.replace(/[^0-9.]/g, '')),
    });
  };

  return (
    <ModalBase modalIsOpen={modalIsOpen} setIsOpen={setIsOpen}>
      <div className="modal-base general success action flex--4">
        <span onClick={() => setIsOpen(false)}>&times;</span>
        <form
          autoComplete="off"
          style={{ display: 'flex', flexDirection: 'column', gap: '20px', position: 'relative' }}
        >
          <h4>{title}</h4>

          <Input
            {...OverideInputStyle}
            label="Units"
            placeholder="Enter units"
            height="60px"
            className="user-form-input"
            type="number"
            value={formData.units}
            onChange={(e) => setFormData({ ...formData, units: e.target.value })}
          />

          <Input
            {...OverideInputStyle}
            label="Amount Paid"
            placeholder="₦500,000"
            height="60px"
            className="user-form-input"
            type="number"
            value={formData.amountPaid}
            onChange={(e) => setFormData({ ...formData, amountPaid: e.target.value })}
          />

          <Select
            label="Fund Flex"
            {...OverideInputStyle}
            outlineColor="none"
            borderStyle="none"
            height="60px"
            placeholder="Fund User Flex Wallet"
            name="fundFlex"
            id="fundFlex"
            value={formData.fundFlex}
            onChange={(e: any) => setFormData({ ...formData, fundFlex: e })}
            options={[
              {
                value: 'true',
                label: 'True',
              },
              {
                value: 'false',
                label: 'False',
              },
            ]}
          />

          {/* Chrome pairs the nearest text input before a password field as "username".
              This hidden field absorbs that fill so Fund Flex is not overwritten. */}
          <div aria-hidden="true" style={{ height: 0, overflow: 'hidden' }}>
            <input type="text" name="prevent-username-autofill" autoComplete="username" tabIndex={-1} />
          </div>

          <div className="input-cont flex--2">
            <Input
              {...OverideInputStyle}
              label="Input Password"
              className="user-form-input"
              height="60px"
              placeholder="******"
              type={showPassword ? 'text' : 'password'}
              onChange={(e) => setPassword(e.target.value)}
              id="investify-admin-password"
              name="adminConfirmPassword"
              {...({ autoComplete: 'new-password' } as object)}
              value={password}
            />
            <div className="password-icon pointer" onClick={() => setShowPassword(!showPassword)}>
              {showPassword ? <FaEyeSlash size={20} /> : <IoEyeSharp size={20} />}
            </div>
          </div>

          <div className="button-cont flex--2">
            <button type="button" onClick={() => setIsOpen(false)}>
              Cancel
            </button>
            <button onClick={onButtonClick} style={{ backgroundColor: actionColor }} disabled={isLoading}>
              {isLoading ? 'Loading...' : 'Yes'}
            </button>
          </div>
        </form>
      </div>
    </ModalBase>
  );
};

export default ModalInvestifyAction;
